/**
 * Created by pajicv on 10/5/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import TaskCollapsed from './TaskCollapsed';
import { spinnerWhileLoading } from '../../utils/components';

const populateProjectMembers = [{
  child: 'members',
  root: 'users',
  populateByKey: true
}];

const populateTaskSubTasks = [
  {
    child: 'subTasks',
    root: 'subTasks'
  }, {
    child: 'cycle',
    root: 'cycles'
  }];

const enhance = compose(
  firebaseConnect((props) => {
    const { projectId, taskId } = props;
    return [{
      path: `projects/${projectId}`,
      populates: populateProjectMembers
    }, {
      path: `tasks/${taskId}`,
      populates: populateTaskSubTasks
    }, {
      path: 'subTasks', queryParams: ['orderByChild=task', `equalTo=${taskId}`]
    }];
  }),
  connect(
    (state, props) => {
      const { projectId, taskId } = props;
      return ({
        project: populate(state.firebase, `projects/${projectId}`, populateProjectMembers),
        task: populate(state.firebase, `tasks/${taskId}`, populateTaskSubTasks),
        auth: state.firebase.auth,
        subTasks: state.firebase.ordered.subTasks,
          taskId,
          projectId
      });
    }
  ),
  spinnerWhileLoading(['project', 'task', 'subTasks'])
);

export default enhance(TaskCollapsed);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskCollapsed.enhancer.js